import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    profileControllerShowMeV1: build.query<
      ProfileControllerShowMeV1ApiResponse,
      ProfileControllerShowMeV1ApiArg
    >({
      query: () => ({ url: `/api/v1/profile` }),
    }),
    profileControllerUpdateMeV1: build.mutation<
      ProfileControllerUpdateMeV1ApiResponse,
      ProfileControllerUpdateMeV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/profile`,
        method: 'PUT',
        body: queryArg.updateMeBody,
      }),
    }),
    profileControllerGetMyTenantsV1: build.query<
      ProfileControllerGetMyTenantsV1ApiResponse,
      ProfileControllerGetMyTenantsV1ApiArg
    >({
      query: () => ({ url: `/api/v1/profile/tenants` }),
    }),
    profileControllerVerifyTelegramV1: build.mutation<
      ProfileControllerVerifyTelegramV1ApiResponse,
      ProfileControllerVerifyTelegramV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/profile/verify-telegram`,
        method: 'POST',
        body: queryArg.verifyTelegramBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type ProfileControllerShowMeV1ApiResponse = /** status 200 Profile details */ ShowMeResponse;
export type ProfileControllerShowMeV1ApiArg = void;
export type ProfileControllerUpdateMeV1ApiResponse =
  /** status 200 Returns updated profile details */ UpdateMeResponse;
export type ProfileControllerUpdateMeV1ApiArg = {
  updateMeBody: UpdateMeBody;
};
export type ProfileControllerGetMyTenantsV1ApiResponse =
  /** status 200 List of tenants the user is a member of */ GetMyTenantsResponse;
export type ProfileControllerGetMyTenantsV1ApiArg = void;
export type ProfileControllerVerifyTelegramV1ApiResponse =
  /** status 200 Returns updated profile details */ VerifyTelegramResponse;
export type ProfileControllerVerifyTelegramV1ApiArg = {
  verifyTelegramBody: VerifyTelegramBody;
};
export type ShowMeResponse = {
  /** User ID */
  id: number;
  /** User email address */
  email: string;
  /** Full name */
  fullname: string;
  /** Company name */
  company: string;
  /** Is Telegram linked */
  telegram: boolean;
  /** User's Telegram chat ID or null */
  telegramChatID: null | string;
  /** User status (-1: error/invalid, 0: disabled, 1: new, 2: email confirmed, 3: active user with setted 2FA) */
  status: number;
  /** Referral code for registration */
  referral: string;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Human-readable user status label */
  statusLabel?: string;
  referralUrl: string;
  roles: {
    /** Role ID */
    id: number;
    /** Role name */
    name: string;
  }[];
};
export type UpdateMeResponse = {
  /** User ID */
  id: number;
  /** User email address */
  email: string;
  /** Full name */
  fullname: string;
  /** Company name */
  company: string;
  /** Is Telegram linked */
  telegram: boolean;
  /** User's Telegram chat ID or null */
  telegramChatID: null | string;
  /** User status (-1: error/invalid, 0: disabled, 1: new, 2: email confirmed, 3: active user with setted 2FA) */
  status: number;
  /** Referral code for registration */
  referral: string;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Human-readable user status label */
  statusLabel?: string;
  referralUrl: string;
  roles: {
    /** Role ID */
    id: number;
    /** Role name */
    name: string;
  }[];
};
export type UpdateMeBody = {
  /** Full name */
  fullname?: string;
  /** Company name */
  company?: string;
};
export type GetMyTenantsResponse = {
  /** Tenant ID */
  id: number;
  /** Tenant slug (unique identifier, must contain at least one letter) */
  slug: string;
  /** Tenant name */
  name: string;
  /** Whether this is the system tenant (computed from slug) */
  isSystem: boolean;
}[];
export type VerifyTelegramResponse = {
  /** User ID */
  id: number;
  /** User email address */
  email: string;
  /** Full name */
  fullname: string;
  /** Company name */
  company: string;
  /** Is Telegram linked */
  telegram: boolean;
  /** User's Telegram chat ID or null */
  telegramChatID: null | string;
  /** User status (-1: error/invalid, 0: disabled, 1: new, 2: email confirmed, 3: active user with setted 2FA) */
  status: number;
  /** Referral code for registration */
  referral: string;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
  /** Human-readable user status label */
  statusLabel?: string;
  referralUrl: string;
  roles: {
    /** Role ID */
    id: number;
    /** Role name */
    name: string;
  }[];
};
export type VerifyTelegramBody = {
  /** Telegram verification code */
  code: string;
};
